<template>
  <div class="nacin">
    <div class="tekst">
      <h1>Načini plaćanja</h1>
      <h2>1. Plaćanje preko računa</h2>
      <p>Svoju porudžbinu možete platiti direktnom uplatom na žiro-račun VND namještaja kod Lovcen banke AD 565-4539-50 i Hipotekarne banke AD 520-13006-51, uz obavezno navođenje odgovarajućeg poziva na broj koji se generiše prilikom naručivanja.</p>
      <h2>2. Placanje prilikom isporuke</h2>
      <p>Kod plaćanja prilikom isporuke porudžbinu je moguće platiti :
        <ul>
          <li>Gotovinom,</li>
          <li>Karticom (MAESTRO, VISA, VISA ELECTRON, MASTER CARD),</li>
          <li>Premijum karticom Hipotekarne banke AD do <strong>12 rata bez kamate</strong>.</li>
        </ul>
      </p>
      <h2>3. Za plaćanje porudžbine prije isporuke odobravamo dodatni popust.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nacin',
  components: {
  },
  metaInfo () {
    return {
      title: 'Načini plaćanja - VND online diskont namještaja',
      meta: [
        { name: 'description', content: 'Poručite namještaj online, najpovoljnije u Crnoj Gori. Popust za avansno plaćanje. Mogućnost plaćanja prilikom isporuke. Preko računa, gotovina, kartice ili na rate Premium karticom Hipotekarne banke do 12 rata bez kamate.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'vndnamjestaj' },
        { property: 'og:title', content: 'Kontakt - VND namještaj' },
        { property: 'og:image', content: this.sImage },
        { property: 'og:url', content: 'https://vndnamjestaj.me' + this.$route.path }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.nacin{
  position: absolute;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding: 5vw 0.6vw 2vw;
  z-index: 100;
  background-color: #f8f9fa;
  overflow: hidden;
  overflow-y: auto;
}
.tekst{
  width: 58vw;
  position: relative;
  margin: 0px auto;
  text-align: center;
  line-height: 1.5;
  h1, p{
    margin-bottom: 2vw;
  }
  h2, p{
    text-align: justify;
    text-indent: 2vw;
  }
}

@media only screen and (max-width: 600px) {
.nacin{
  position: relative;
}
.tekst{
  width: 85vw;
  position: relative;
  margin: 0px auto;
  text-align: center;
  line-height: 1.5;
  padding: 10vw 0px;
  h1, p{
    margin-bottom: 2vw;
  }
  h2, p{
    text-align: justify;
    text-indent: 2vw;
  }
}
}
</style>
